module.exports = __webpack_public_path__ + "media/images/inmediato-6876c44020410ffb74dd3b0175abd408.png";